var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#123766"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 24.0625V21.6125C11.5 21.1167 11.6094 20.6609 11.8281 20.2453C12.0469 19.8297 12.3375 19.5125 12.7 19.2937C13.475 18.8417 14.2625 18.5026 15.0625 18.2766C15.8625 18.0505 16.675 17.9375 17.5 17.9375C18.325 17.9375 19.1375 18.0505 19.9375 18.2766C20.7375 18.5026 21.525 18.8417 22.3 19.2937C22.6625 19.5125 22.9531 19.8297 23.1719 20.2453C23.3906 20.6609 23.5 21.1167 23.5 21.6125V24.0625H11.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0281 15.9094C15.7135 16.5948 16.5375 16.9375 17.5 16.9375C18.4625 16.9375 19.2865 16.5948 19.9719 15.9094C20.6573 15.224 21 14.4 21 13.4375C21 12.475 20.6573 11.651 19.9719 10.9656C19.2865 10.2802 18.4625 9.9375 17.5 9.9375C16.5375 9.9375 15.7135 10.2802 15.0281 10.9656C14.3427 11.651 14 12.475 14 13.4375C14 14.4 14.3427 15.224 15.0281 15.9094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/Owner.7a34b5d726046229eb9ac0c3458fbf7e.svg";
export { ForwardRef as ReactComponent };